import { call, put, takeLatest, all } from 'redux-saga/effects';

import { addAPIError, removeAPIError } from 'redux/apiErrors/sagas';

import { listCustomerLoyalty } from './api';
import {
  LIST_CUSTOMER_LOYALTY_REQUEST,
  LIST_CUSTOMER_LOYALTY_SUCCESS,
  CUSTOMER_LOYALTY_LIST_REQUESTING,
  RESET_CUSTOMER_LOYALTY_ISFETCHING
} from './constants';

function* list(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CUSTOMER_LOYALTY_LIST_REQUESTING });
    const response = yield call(listCustomerLoyalty, action.queryString);
    yield put({
      type: LIST_CUSTOMER_LOYALTY_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    yield put({ type: RESET_CUSTOMER_LOYALTY_ISFETCHING });
    yield call(addAPIError, error);
  }
}

function* watchList() {
  yield takeLatest(LIST_CUSTOMER_LOYALTY_REQUEST, list);
}

export default function* customerLoyaltySagas() {
  yield all([watchList()]);
}
